import firstMemoText from "../assets/others/firstMemo";
import { Memos } from "../models/memos";

const uuid = require("uuid/v1");
const firstCatId = "firstCat";

const initialState: Memos = {
  [uuid()]: {
    text: firstMemoText,
    cat: [firstCatId],
    _createdAt: new Date(),
    _modifiedAt: new Date()
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "ADD_MEMO":
      return {
        ...state,
        [action.id]: {
          text: "",
          cat: [action.cat],
          _createdAt: new Date(),
          _modifiedAt: new Date()
        }
      };
    case "SAVE_MEMO":
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          text: action.text,
          _modifiedAt: new Date()
        }
      };
    case "RESTORE_MEMO":
      return {
        ...state,
        [action.id]: action.memo
      };
    case "CHANGE_MEMO_CATEGORY":
      // console.log(action);
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          cat: [action.categoryId],
          _modifiedAt: new Date()
        }
      };
    case "ARCHIVE_MEMO":
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          cat: []
        }
      };
    case "DELETE_MEMO":
      delete state[action.id];
      return {
        ...state
      };
    case "DELETE_ALL_MEMO":
      return initialState;
    case "DELETE_ALL_MEMO_WITHOUT_FIRSTMEMO":
      return {};
    default:
      return state;
  }
}
